import React, { useState } from 'react';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as FilterIcon} from '../../components/svgs/filterIcon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';
import StatusDropdown from '../../components/StatusDropdown';

import { Link } from 'react-router-dom';
import DropdownSVG from '../../components/OrderDropdown';
import SalesByItemStatusCard from './SalesByItemStatusCard';

const options = [
    { label: 'Edit Order', link: '#' },
    { label: 'Duplicate Order', link: '#' },
    { label: 'Print Details', link: '#' },
    { label: 'Archive Orders', link: '#' }
  ];

  // laundry status data
const laundryStatus = [
    { label: 'All', link: '#' },
    { label: 'Binned', link: '#' },
    { label: 'Washing', link: '#' },
    { label: 'Drying', link: '#' },
    { label: 'Folding', link: '#' },
  ];


const SalesByItemTab = () => {

    const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'All',
      tableData: [
        { serviceName: 'Wash N Fold', amountGenerated: '$40.00', unitOfMeasure: 'Per item', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { serviceName: 'Same Day Service', amountGenerated: '$40.00', unitOfMeasure: 'Per pound', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { serviceName: 'Large Bag', amountGenerated: '$40.00', unitOfMeasure: 'Per item', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { serviceName: 'Labcoat', amountGenerated: '$40.00', unitOfMeasure: 'Per pound', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { serviceName: 'Blanket', amountGenerated: '$40.00', unitOfMeasure: 'Per item', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details'},
        { serviceName: 'Throw Pillows', amountGenerated: '$40.00', unitOfMeasure: 'Per pound', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details'},
      ]
    },
    {
      title: 'Personal',
      tableData: [
        // Add data for Tab 2
        { serviceName: 'Wash N Fold', amountGenerated: '$40.00', unitOfMeasure: 'Per item', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { serviceName: 'Wash N Fold', amountGenerated: '$40.00', unitOfMeasure: 'Per pound', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details' },
      ]
    },
    {
      title: 'Commercial',
     
      tableData: [
        { serviceName: 'Wash N Fold', amountGenerated: '$40.00', unitOfMeasure: 'Per pound', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details' },
        { serviceName: 'Wash N Fold', amountGenerated: '$40.00', unitOfMeasure: 'Per item', pricePerUnit: '$1.99', minimumSize: '10lbs', viewButton: '/owner/reports/invoicing/invoicing-details' },
     
      ]
    }
  ];


  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
    <section className='mt-10 flex gap-10'>
    <SalesByItemStatusCard statusTitle={'Most requested'} noOfOrdersClassName={'custom-style'} serviceType={'Wash and fold'} noOfOrders={32}  dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-36" />}/>
    <SalesByItemStatusCard statusTitle={'Most profitable'} noOfOrdersClassName={'custom-style'} serviceType={'Same day service'} revenue={'$ 300'} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="ml-36" />}/>
            
    </section>

    <div className="tab-container mt-10">

        <div className="tab-titles">
        {tabs.map((tab, index) => (
            <div
            key={index}
            className={`tab-title ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
            >
           
            <div className={`tab-label invoicing-tab ${activeTab === index ? 'active' : ''}`}>{tab.title}</div>
            </div>
        ))}
        </div>

        <section className='flex search-filter-section mt-4 mb-4 ml-4'>
            <section>
                <form action="">
                <label htmlFor="" className="flex flex-col order-search-input">
                    <SearchIcon className='order-search-icon search-icon'/>
                    <input type="text" placeholder="Search" className="mt-2"/>
                </label>
                </form>
            </section>
            <section className='flex gap-10 mt-10 ml-20'>
                <div className='flex gap-4'>
                    <FilterIcon/>
                    <p className='filter-section-text'>Filter</p>

                </div>
                <div className='flex gap-4'>
                    <ExportIcon/>
                    <p className='filter-section-text'>Export as csv</p>
                    
                </div>
            </section>
        </section>    
            

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
            <table className="custom-table custom-order-table">

              <thead>
                <tr className='table-head'>
                  <th className=''>
                  Service name
                    <span className="filter-icon">
                      <ActiveIcon />
                      
                    </span>
                  </th>

                  <th>
                    Amount Generated
                    <span className="filter-icon">
                    <ActiveIcon />
                    </span>
                  </th>

                  <th>
                  Unit of measure
                    <span className="filter-icon">
                      <ActiveIcon />
                    </span>
                  </th>
                  
                  <th>
                  Price per unit
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>

                  <th>
                  Minimum size
                    <span className="filter-icon">
                        <ActiveIcon />
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data-1'>
                      {data.serviceName}
                      
                    </td>

                    <td className='table-data'>
                      {data.amountGenerated}
                    
                    </td>
                  
                    <td className='table-data'>
                      {data.unitOfMeasure}
                    
                    </td>
                   
                     
                    <td className='table-data'>
                      {data.pricePerUnit}
                   
                    </td>
                    
                    <td className='table-data'>
                      {data.minimumSize}
                   
                    </td>
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>
                    <td>
                    <DropdownSVG options={options} className="my-dropdown" />
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default SalesByItemTab